import { Capacitor } from '@capacitor/core'
export function isNative() {
  return Capacitor.isNativePlatform()
}
